import { render, staticRenderFns } from "./order-placed-message-info.vue?vue&type=template&id=3e7fc4e0&"
import script from "./order-placed-message-info.vue?vue&type=script&lang=js&"
export * from "./order-placed-message-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports